module.exports = __webpack_public_path__ + "images/create-team/wavy-border.1ea9c6f8c41d10be0e12.svg";